/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { cloneElement, PropsWithChildren } from "react";
import sass from "./gr.module.sass";
import NewCheckBox from "components-new/NewCheckBox";
import cn from "classnames";
import { INewCheckBox } from "components-new/NewCheckBox/NewCheckBox";

interface IGroupCheck extends PropsWithChildren {
	label?: string;
	required?: boolean;
	disabledGroup?: boolean;
}

interface ICheck extends INewCheckBox {
	label: string;
}

/**
 * @description Компонент обёртка для чекбокса, добавляет стили необходимые для визуализации группы кнопок
 *
 * @param {IGroupCheck} props
 * @param {string} props.label - подпись кнопки
 * @param {INewCheckBox} props.rest - стандартные пропсы для чекбокса или кнопки
 * @constructor
 */
export const Item: React.FC<ICheck> = ({ label, ...rest }) => {
	return (
		<label
			className={cn(sass.item, {
				[sass["item-active"]]: rest.checked,
				[sass["item-disabled"]]: rest.disabled,
			})}>
			<NewCheckBox {...rest} />
			{label}
		</label>
	);
};

/**
 * @description Компонент обортка для создания поля с выбором из чекбоксов и радио кнопок
 *
 * @example пример использования
 * const Foo:React.FC = ()=>{
   const [someField,setSomeField] = useState({
        fieldOne:true,
        fieldTwo:false,
        fieldThree:true
   })
   const changeItem = (event: React.ChangeEvent<HTMLInputElement>)=>{
        const {name,checked} = e.target
        setSomeField(prevState=>({...prevState,[name]:!checked}))
   }
   return (
   <GroupCheck.Wrapper label={'Выберете необходимые элементы'}>
       <GroupCheck.Item label={'Значение 1'} name={'fieldOne'} checked={someField.fieldOne} onChange={changeItem}/>
       <GroupCheck.Item label={'Значение 2'} name={'fieldTwo'} checked={someField.fieldTwo} onChange={changeItem}/>
       <GroupCheck.Item label={'Значение 3'} name={'fieldThree'} checked={someField.fieldThree} onChange={changeItem}/>
   </GroupCheck.Wrapper>
 * )}
 *
 *
 * @param {IGroupCheck} props
 * @param {string} props.label - заголовок для поля
 * @param {boolean} [props.disabledGroup] - блокирует вложенные элементы
 * @param {any} props.children - любые элементы
 * @param {any} [props.required] - занчение для отображения звездочки в лейбле, чтобы дать понять пользователю
 * что здесь нужно что-нибудь заполнить
 * @constructor
 */
const GroupCheck: React.FC<IGroupCheck> = ({ disabledGroup = false, children, label, required = false }) => {
	return (
		<div className={cn(sass.wrapper, { [sass["wrapper-disabled"]]: disabledGroup })}>
			<div tabIndex={-1} className={sass.field}>
				{children && Array.isArray(children)
					? children.map((_, key) =>
							cloneElement(_ as any, { ..._.props, key, ...(disabledGroup && { disabled: disabledGroup }) }),
					  )
					: children &&
					  cloneElement<any>(children as React.ReactElement<ICheck>, {
							...(children as React.ReactElement<ICheck>).props,
							...(disabledGroup && { disabled: disabledGroup }),
					  })}
				{/*{children}*/}
			</div>
			<span className={sass.label}>
				{label}
				{required && <sup className={sass.required}>*</sup>}
			</span>
		</div>
	);
};

export default GroupCheck;
